import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLimit = (store: StoreSchema) => store.instanceEvents.limit